import { Co2MaterialLibraryScope, Co2MaterialSettingType } from "@api/apiClient";
import { queryClient } from "@hooks/useGlobalState";
import i18n from "@i18n/i18n";
import { Container, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import { useEffect } from "react";
import MaterialGrid from "./MaterialGrid";
export interface MaterialsPageProps {
  mode: Co2MaterialSettingType;
  projectId?: string | null;
  profileId?: string | null;
  originScreen: "Admin" | "Project" | "Scenario";
}

const MaterialsPage = observer((props: MaterialsPageProps) => {
  const materialLibraryScope =
    props.originScreen === "Admin" ? Co2MaterialLibraryScope.Application : Co2MaterialLibraryScope.Project;
  const materialLibraryParentId = props.originScreen === "Admin" ? undefined : props.projectId || undefined;
  const isEmbeddedInDialog = props.originScreen === "Project" || props.originScreen === "Scenario";

  useEffect(() => {
    // Emission factors start with a clean grid/dropdown each time; do not restore cached selections.
    void queryClient.removeQueries({ queryKey: ["materialLibraries"], exact: false });
    void queryClient.removeQueries({ queryKey: ["materialTypes"], exact: false });
    void queryClient.removeQueries({ queryKey: ["materialTypesQuery"], exact: false });
    void queryClient.removeQueries({ queryKey: ["materialTypeOptions"], exact: false });
  }, [props.originScreen, props.projectId]);

  return (
    <Container
      maxWidth={false}
      sx={{
        height: isEmbeddedInDialog ? "auto" : "100%",
        width: "100%",
      }}
    >
      <Grid
        mt={2}
        container
        spacing={2}
        sx={{
          display: "flex",
          flexDirection: "column",
          height: isEmbeddedInDialog ? "auto" : "100%",
        }}
      >
        <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
          <Typography variant="h6" fontWeight="bold">
            {i18n.t("materials-page.title")}
          </Typography>
        </Grid>
        <Grid
          size={12}
          sx={{
            display: "flex",
            flexGrow: isEmbeddedInDialog ? 0 : 1,
            width: "100%",
            position: "relative",
            alignItems: "flex-start",
          }}
        >
          <MaterialGrid
            materialLibraryScope={materialLibraryScope}
            materialLibraryParentId={materialLibraryParentId}
            compactLayout={isEmbeddedInDialog}
            gridHeight={isEmbeddedInDialog ? 400 : undefined}
          />
        </Grid>
      </Grid>
    </Container>
  );
});

export default MaterialsPage;
